export default {
  dataQEC: null,
  errorMessageEmail: '',
  errorMessageEfecty: '',
  errorPaymentPSE: '',
  errorStateService: null,
}
